exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device-edit-dlg {\n  margin: 25px; }\n\n.flag.fa {\n  font-size: 30px;\n  color: #4f4f4f; }\n\n.badge {\n  display: inline-block;\n  padding: .35em .65em;\n  font-size: .75em;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25rem;\n  background-color: #6c757d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/devices/edit.scss
// module id = ../../../../../src/app/pages/admin/devices/edit.scss
// module chunks = main